import { gql } from '@apollo/client';

export const updateQuestionnaireMutation = gql`
  mutation ($id: uuid!, $set: questionnaires_set_input!) {
    update_questionnaires_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
    }
  }
`;
